import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import { Box, Typography } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import OpenPositions from "../components/OpenPositions";
import PlaceOrder from "../components/PlaceOrder";
import BalanceHistory from "../components/BalanceHistory";
import { getSelectedUserAccountFromLocalStorage } from "../utils/data";

const Scalper = () => {
    const [selectedAccount, setSelectedAccount] = useState(getSelectedUserAccountFromLocalStorage());

    useEffect(() => {
        // Listen for global user account changes
        const handleUserAccountChange = (event) => {
            setSelectedAccount(event.detail);
        };

        window.addEventListener('userAccountChanged', handleUserAccountChange);
        
        return () => {
            window.removeEventListener('userAccountChanged', handleUserAccountChange);
        };
    }, []);

    if (!selectedAccount) {
        return (
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="400px" gap={2}>
                <AccountBalanceWalletIcon color="disabled" sx={{ fontSize: 64 }} />
                <Typography variant="h5" color="text.secondary">
                    No User Account Selected
                </Typography>
                <Typography variant="body1" color="text.secondary" textAlign="center">
                    Please select a user account from the dropdown in the header to start trading.
                </Typography>
            </Box>
        );
    }

    return (
        <Grid container spacing={2}>
            <Grid size={8}>
                <OpenPositions userAccountId={selectedAccount.id} />
            </Grid>
            <Grid size={4} >
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <PlaceOrder broker={selectedAccount.broker} userAccountId={selectedAccount.id} />
                    </Grid>
                    {/* <Grid size={12}>
                        <BalanceHistory />
                    </Grid> */}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Scalper;
